<template lang="pug">
  .container.grid-lg
    load-manager(:status="status")
      .card.mt-2(v-if='current')
        .card-header
          .card-title.h5 {{ current.subject }}
        .card-body(v-if='current.addresses')
          .py-1(v-for='a in current.addresses')
            item-col(:label='mapAddresType[a.type]', :value='addresLabel(a)')
        .card-body
          .columns
            item-col.py-2.col-6.col-xs-12(label='Escopo', :value='current.scope')
            item-col.py-2.col-6.col-xs-12(label='Escopo ID', :value='current.scope_id')
            item-col.py-2.col-6.col-xs-12(label='Inserido em', :value='current.created_at | date')
            item-col.py-2.col-6.col-xs-12(label='Enviado em', :value='current.sent_at | date')
        .card-body
          .divider.text-center(data-content='Conteúdo do e-mail')
          .py-2(v-if='current.content')
            p(v-html='current.content.value')
</template>

<script>
export default {
  vuex: {
    emailHistoricos: {
      state: ['current', 'status'],
      actions: ['fetchOne'],
    },
  },

  data() {
    return {
      mapAddresType: {
        to: 'Para',
        from: 'De',
        reply_to: 'Responder Para',
      },
    }
  },

  methods: {
    addresLabel(address) {
      if (address.name) {
        return `${address.name} <${address.email_address}>`
      }

      return address.email_address
    },
  },

  created() {
    this.fetchOne(this.$route.params.id)
  },
}
</script>
